import styled from 'styled-components';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { TAB_VARIANT, TAB_ALIGNMENT } from './constants.js';
import { typography } from '../../typography/typography.js';

var getTabAlignment = function getTabAlignment(position) {
  var mobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  switch (position) {
    case TAB_ALIGNMENT.LEFT:
      return 'flex-start';

    case TAB_ALIGNMENT.RIGHT:
      return 'flex-end';

    case TAB_ALIGNMENT.CENTER:
      return 'center';

    default:
      if (mobile) {
        return 'flex-start';
      }

      return 'center';
  }
};

var getTabMargin = function getTabMargin(variant, numTabs) {
  var breakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var margin = '0';

  if (variant === TAB_VARIANT.DEFAULT) {
    margin = numTabs <= 3 ? '0 60px' : '0 40px';

    if (breakpoint) {
      margin = numTabs <= 3 ? '0 30px' : '0 16px';
    }
  }

  return margin;
};

var getTabPadding = function getTabPadding(variant, numTabs) {
  var breakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var padding = '0';

  if (variant === TAB_VARIANT.BOX || variant === TAB_VARIANT.BOX_LINE_TOP) {
    padding = numTabs <= 3 ? '0 60px' : '0 40px';

    if (breakpoint) {
      padding = numTabs <= 3 ? '0 30px' : '0 16px';
    }
  }

  return padding;
};

var getTabBorderColor = function getTabBorderColor(_ref) {
  var variant = _ref.variant,
      selected = _ref.selected,
      theme = _ref.theme;
  var highlightColor = theme.colorPalette.primaryColors.main.shade_default;
  var defaultColor = theme.colorPalette.neutralColors.light.shade_default;

  if (variant === TAB_VARIANT.DEFAULT || variant === TAB_VARIANT.GREY) {
    if (selected) {
      return "border-color: ".concat(highlightColor, ";");
    }

    return 'border-color: transparent;';
  }

  if (variant === TAB_VARIANT.BOX) {
    if (selected) {
      return "border-color: ".concat(defaultColor, " ").concat(defaultColor, " ").concat(highlightColor, " ").concat(defaultColor, ";");
    }

    return "border-color: ".concat(defaultColor, ";");
  }

  if (variant === TAB_VARIANT.BOX_LINE_TOP) {
    if (selected) {
      return "border-color: ".concat(highlightColor, " ").concat(defaultColor, " transparent ").concat(defaultColor, ";");
    }

    return "border-color: ".concat(defaultColor, ";");
  }

  return 'border-color: transparent;';
};

var getTabBorderStyle = function getTabBorderStyle(variant, tabPosition) {
  var borderStyle = 'none none solid none ';

  if (variant === TAB_VARIANT.BOX || variant === TAB_VARIANT.BOX_LINE_TOP) {
    if (tabPosition === 0) {
      borderStyle = 'solid';
    } else {
      borderStyle = 'solid solid solid none';
    }
  }

  return borderStyle;
};

var getTabBorderWidth = function getTabBorderWidth(variant, selected) {
  var borderWidth = '0 0 4px 0';

  if (variant === TAB_VARIANT.BOX || variant === TAB_VARIANT.BOX_LINE_TOP) {
    borderWidth = '1px';

    if (selected) {
      borderWidth = variant === TAB_VARIANT.BOX ? "1px 1px 4px 1px" : "4px 1px 1px 1px";
    }
  }

  return borderWidth;
};

var getTabBackgroundColor = function getTabBackgroundColor(variant, selected, theme) {
  var backgroundColor = 'transparent';

  if ((variant === TAB_VARIANT.BOX || variant === TAB_VARIANT.BOX_LINE_TOP) && selected) {
    backgroundColor = theme.colorPalette.neutralColors.light.shade_white;
  }

  return backgroundColor;
};

var ScrollButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__ScrollButton",
  componentId: "sc-10s25q7-0"
})(["border:none;background:", ";padding:0;margin:0;width:60px;@media (max-width:", "px){width:36px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, BREAKPOINTS.PHONE_PORTRAIT_MED);
var TabListWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__TabListWrapper",
  componentId: "sc-10s25q7-1"
})(["@media (max-width:", "px){display:flex;width:100%;}"], BREAKPOINTS.MAX_1024);
var TabList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__TabList",
  componentId: "sc-10s25q7-2"
})(["display:flex;list-style-type:none;justify-content:", ";padding-left:", ";margin:0px;height:", ";@media (max-width:", "px){justify-content:", ";height:", ";}@media (max-width:", "px){height:", ";padding-left:", ";}@media (max-width:", "px){justify-content:", ";}background-color:", ";border-bottom:1px solid ", ";", " ", " ", ""], function (_ref3) {
  var tabAlignment = _ref3.tabAlignment;
  return getTabAlignment(tabAlignment);
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant === TAB_VARIANT.GREY ? '20px' : '0px';
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === TAB_VARIANT.GREY ? '64px' : '80px';
}, BREAKPOINTS.MAX_1024, function (_ref6) {
  var showScrollButtons = _ref6.showScrollButtons,
      tabAlignment = _ref6.tabAlignment;
  return showScrollButtons ? 'left' : getTabAlignment(tabAlignment);
}, function (_ref7) {
  var variant = _ref7.variant;
  return variant === TAB_VARIANT.GREY ? '64px' : '70px';
}, BREAKPOINTS.MAX_768, function (_ref8) {
  var variant = _ref8.variant;
  return variant === TAB_VARIANT.GREY ? '64px' : '60px';
}, function (_ref9) {
  var variant = _ref9.variant;
  return variant === TAB_VARIANT.GREY ? '4px' : '0px';
}, BREAKPOINTS.PHONE_PORTRAIT_MED, function (_ref10) {
  var showScrollButtons = _ref10.showScrollButtons,
      mobileTabAlignment = _ref10.mobileTabAlignment;
  return showScrollButtons ? 'left' : getTabAlignment(mobileTabAlignment, true);
}, function (_ref11) {
  var variant = _ref11.variant,
      theme = _ref11.theme;
  return variant === TAB_VARIANT.GREY ? theme.colorPalette.neutralColors.light.shade_default : theme.colorPalette.neutralColors.light.shade_light_2;
}, function (_ref12) {
  var variant = _ref12.variant,
      theme = _ref12.theme;
  return variant === TAB_VARIANT.DEFAULT ? theme.colorPalette.neutralColors.light.shade_dark_2 : 'transparent';
}, function (_ref13) {
  var isSticky = _ref13.isSticky;
  return isSticky && "position: sticky;\n    top: 0;\n  ";
}, function (_ref14) {
  var variant = _ref14.variant;

  if (variant === TAB_VARIANT.GREY) {
    return "\n      @media (max-width: ".concat(BREAKPOINTS.MAX_1024, "px) {\n        overflow-x: auto;\n        padding: 0;\n        width: 100%;\n      }\n      ::-webkit-scrollbar {\n        display: none;\n      }\n      -ms-overflow-style: none;\n      scrollbar-width: none;\n      ");
  }

  return '';
}, function (_ref15) {
  var tabsWrapperStyle = _ref15.tabsWrapperStyle;
  return tabsWrapperStyle;
});
process.env.NODE_ENV !== "production" ? TabList.displayName = 'TabList' : void 0;
var TabItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "styledComponents__TabItem",
  componentId: "sc-10s25q7-3"
})(["display:flex;text-align:center;padding:", ";@media (max-width:", "px){padding:", ";}&:first-of-type{padding-left:0;}&:last-of-type{padding-right:0;}"], function (_ref16) {
  var variant = _ref16.variant;
  return variant === TAB_VARIANT.GREY ? '0 20px' : '0';
}, BREAKPOINTS.MAX_1024, function (_ref17) {
  var variant = _ref17.variant;
  return variant === TAB_VARIANT.GREY ? '0 16px' : '0';
});
process.env.NODE_ENV !== "production" ? TabItem.displayName = 'TabItem' : void 0;
var TabButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__TabButton",
  componentId: "sc-10s25q7-4"
})(["align-items:center;background-color:", ";border-style:", ";", " border-width:", ";color:", ";cursor:", ";display:flex;font-family:", ";font-size:", ";font-weight:", ";height:100%;justify-content:center;overflow:hidden;position:relative;", " text-align:left;text-overflow:ellipsis;white-space:", ";margin:", ";padding:", ";@media (max-width:", "px){margin:", ";padding:", ";font-size:", ";}@media (max-width:", "px){margin:", ";padding:", ";}&:hover{text-shadow:", ";}", ""], function (_ref18) {
  var variant = _ref18.variant,
      selected = _ref18.selected,
      theme = _ref18.theme;
  return getTabBackgroundColor(variant, selected, theme);
}, function (_ref19) {
  var variant = _ref19.variant,
      tabPosition = _ref19.tabPosition;
  return getTabBorderStyle(variant, tabPosition);
}, getTabBorderColor, function (_ref20) {
  var variant = _ref20.variant,
      selected = _ref20.selected;
  return getTabBorderWidth(variant, selected);
}, function (_ref21) {
  var disabled = _ref21.disabled,
      theme = _ref21.theme;
  return disabled ? theme.colorPalette.neutralColors.light.shade_dark_3 : theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref22) {
  var disabled = _ref22.disabled;
  return disabled ? 'default' : 'pointer';
}, typography.fontFamily, rem(18), function (_ref23) {
  var selected = _ref23.selected;
  return selected ? '600' : '400';
}, function (_ref24) {
  var disabled = _ref24.disabled;
  return disabled && "pointer-events: none;";
}, function (_ref25) {
  var variant = _ref25.variant;
  return variant === TAB_VARIANT.GREY ? 'nowrap' : 'normal';
}, function (_ref26) {
  var variant = _ref26.variant,
      numTabs = _ref26.numTabs;
  return getTabMargin(variant, numTabs);
}, function (_ref27) {
  var variant = _ref27.variant,
      numTabs = _ref27.numTabs;
  return getTabPadding(variant, numTabs);
}, BREAKPOINTS.MAX_768, function (_ref28) {
  var variant = _ref28.variant,
      numTabs = _ref28.numTabs;
  return getTabMargin(variant, numTabs, true);
}, function (_ref29) {
  var variant = _ref29.variant,
      numTabs = _ref29.numTabs;
  return getTabPadding(variant, numTabs, true);
}, typography.fontSize, BREAKPOINTS.MAX_375, function (_ref30) {
  var variant = _ref30.variant,
      numTabs = _ref30.numTabs;
  return getTabMargin(variant, numTabs, true);
}, function (_ref31) {
  var variant = _ref31.variant,
      numTabs = _ref31.numTabs;
  return getTabPadding(variant, numTabs);
}, function (_ref32) {
  var disabled = _ref32.disabled,
      selected = _ref32.selected,
      theme = _ref32.theme;
  return selected || disabled ? 'none' : "0px 0px 0px ".concat(theme.colorPalette.neutralColors.dark.shade_light_1, ",\n    0px 0px 0px ").concat(theme.colorPalette.neutralColors.dark.shade_light_1);
}, function (_ref33) {
  var tabItemStyle = _ref33.tabItemStyle;
  return tabItemStyle;
});
process.env.NODE_ENV !== "production" ? TabButton.displayName = 'TabButton' : void 0; // Styled components for TabPanel

var TabPanelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__TabPanelWrapper",
  componentId: "sc-10s25q7-5"
})(["font-family:", ";background-color:", ";", ""], typography.fontFamily, function (_ref34) {
  var theme = _ref34.theme,
      variant = _ref34.variant;
  return variant === TAB_VARIANT.GREY ? theme.colorPalette.neutralColors.light.shade_white : theme.colorPalette.neutralColors.light.shade_light_2;
}, function (_ref35) {
  var tabPanelStyle = _ref35.tabPanelStyle;
  return tabPanelStyle;
});
process.env.NODE_ENV !== "production" ? TabPanelWrapper.displayName = 'TabPanelWrapper' : void 0;

export { ScrollButton, TabButton, TabItem, TabList, TabListWrapper, TabPanelWrapper };
